import React from "react"
import PropTypes from "prop-types"
import { OverlayPanel } from "../../../components/atoms/OverlayPanel.atom"
import {
  EVENT_TYPES,
  VACATION_STATUS_CHIP_VARIANTS,
} from "../../../consts/modules/vacations.consts"
import VacationStatusChip from "../../../components/molecules/VacationStatusChip.molecule"
import {
  getVacationState,
  vacationEventHasNotification,
} from "../../../utils/vacation.utils"

const MyVacationsGroupedEventsOverlayPanel = ({
  opRef,
  vacationRequests = [],
  clickedDay,
  handleEventClick = () => { },
  containerSelector = ".calendar-card-container",
}) => {
  const filteredRequests = vacationRequests.filter((event) =>
    isEventOnClickedDay(event, clickedDay)
  )
  return (
    <OverlayPanel
      ref={opRef}
      showCloseIcon
      dismissable={false}
      appendTo={document?.querySelector(containerSelector)}
    >
      <table className="grouped-vacations-popup max-w-25rem overflow-hidden">
        <tbody>
          {filteredRequests.map((e, idx) => (
            <tr
              key={idx}
              className="row"
              onClick={(clickEvent) =>
                handleEventClick(e, clickEvent, {
                  groupedEvents: false,
                })
              }
            >
              <td className="ml-0 max-w-25rem overflow-hidden">
                <span className="text-overflow-ellipsis overflow-hidden white-space-nowrap w-full block">
                  {e.vacationsMotive}
                </span>
              </td>
              <td>
                <VacationStatusChip
                  key={idx}
                  status={getVacationState(e)}
                  notification={vacationEventHasNotification(e)}
                  variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </OverlayPanel>
  )
}

export default MyVacationsGroupedEventsOverlayPanel

const isEventOnClickedDay = (event, clickedDay) =>
  clickedDay >= event.start &&
  clickedDay <= event.end &&
  event.eventType !== EVENT_TYPES.HOLIDAY &&
  !("holidayTypeId" in event)

MyVacationsGroupedEventsOverlayPanel.propTypes = {
  opRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  vacationRequests: PropTypes.array,
  clickedDay: PropTypes.instanceOf(Date),
  handleEventClick: PropTypes.func,
  containerSelector: PropTypes.string,
}
